import { IAnimal } from 'src/dto/animal.dto'

/**
 * Converte string de moeda brasileira para número
 * @example "R$ 1.234,56" => 1234.56
 */
export const convertCurrencyToNumber = (currency: string): number => {
  return Number(currency.replace(/[^0-9,-]+/g, '').replace(',', '.'))
}

/**
 * Calcula o peso total de uma lista de animais
 */
export const getTotalWeight = (animalList: IAnimal[]): number => {
  return animalList.reduce((acc, animal) => {
    return acc + (parseFloat(String(animal.pesoAtual) || '0') || 0)
  }, 0)
}

/**
 * Calcula o preço total baseado no peso e valor da arroba
 * @param totalWeight - Peso total em kg
 * @param valorArroba - Valor da arroba
 * @param arrobaValue - Peso da arroba (padrão: 15kg)
 */
export const calcTotalPrice = (totalWeight: number, valorArroba: number, arrobaValue = 15): number => {
  return (totalWeight / arrobaValue) * valorArroba
}

/**
 * Formata número para moeda brasileira
 * @example 1234.56 => "R$ 1.234,56"
 */
export const formatCurrencyValueString = (value: number): string => {
  return value.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  })
}

/**
 * Calcula o valor total da venda baseado na lista de animais e valor da arroba
 */
export const calculateTotalSaleValue = (animalList: IAnimal[], valorArrobaString: string): string => {
  const totalWeight = getTotalWeight(animalList)
  const valorArroba = convertCurrencyToNumber(valorArrobaString)
  const totalPrice = calcTotalPrice(totalWeight, valorArroba)
  return formatCurrencyValueString(totalPrice)
}
